import { CircularProgress } from '@mui/material';
import React from 'react';

const Spinner = ({ dark = false, ...props }: { dark?: boolean }) => (
  <CircularProgress {...props} color={dark ? 'secondary' : 'primary'} />
);
export default Spinner;
